<template>
  <div class="image-preview">
    <el-container class="page-frame">
      <el-header class="site-header-region">
        <Header />
      </el-header>
      <el-container class="container">
        <el-aside :width="menuWidth + 'px'">
          <Menu @toggleMenu="toggleMenu" />
        </el-aside>
        <el-main>
          <ImageView :is-show-menu="menuWidth > 72" />
        </el-main>
      </el-container>
    </el-container>
    <el-footer class="site-footer-region">
      <Footer />
    </el-footer>
  </div>
</template>

<script>
import Header from '../PdfPreview/modules/Header'
import Menu from '../PdfPreview/modules/Menu'
import Footer from '../PdfPreview/modules/Footer'
import ImageView from './modules/ImageView'

export default {
  name: 'ImagePreview',
  components: {
    Header,
    Menu,
    Footer,
    ImageView
  },
  data () {
    return {
      menuWidth: 72
    }
  },
  methods: {
    toggleMenu (menuWidth) {
      this.menuWidth = menuWidth
    }
  }
}
</script>

<style lang="less" scoped>
.image-preview {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #1a1a2e;
  background: #f5f8fa;
  font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;

  .page-frame {
    min-height: 0;
    flex: 1;
  }

  .container {
    min-width: 0;
    min-height: 0;
    flex: 1;
    width: 100%;
    background: #f3f7f9;

    /deep/ .el-aside {
      overflow: hidden;
      background: #ffffff;
      border-right: 1px solid #e3eceb;
      transition: width 0.18s ease;
    }

    /deep/ .el-main {
      min-width: 0;
      padding: 18px;
      overflow: hidden;
    }
  }

  .site-header-region {
    flex: 0 0 64px;
    padding: 0;
    height: 64px !important;
    z-index: 99;
  }

  .site-footer-region {
    flex: 0 0 64px;
    padding: 0;
    height: 64px !important;
  }
}

@media (max-width: 900px) {
  .image-preview .site-footer-region {
    display: none;
  }
}

@media (max-width: 768px) {
  .image-preview {
    height: 100dvh;
    min-height: 100dvh;

    .page-frame {
      padding-bottom: calc(58px + env(safe-area-inset-bottom));
      box-sizing: border-box;
    }

    .site-header-region {
      flex-basis: 56px;
      height: 56px !important;
    }

    .container {
      /deep/ .el-aside {
        display: none;
      }

      /deep/ .el-main {
        width: 100%;
        padding: 8px;
      }
    }
  }
}
</style>
